export default "__VITE_ASSET__DDo2Ty78__"